import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=726f768c&scoped=true"
import script from "./Total.vue?vue&type=script&lang=ts"
export * from "./Total.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f768c",
  null
  
)

export default component.exports